import { REFRESH_WOMSUSER } from "./actionTypes"

export const refreshWomsUser = womsUser => {
  return {
    type: REFRESH_WOMSUSER,
    payload: womsUser ,
  }
}
